import { JSX } from "react";

interface Props {
  value?: string;
  prefix?: JSX.Element;
  suffix?: JSX.Element;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormInput = ({
  value,
  className,
  inputClassName,
  onChange,
  prefix,
  suffix,
  placeholder,
  disabled,
}: Props) => {
  return (
    <div
      className={`bg-white/08 rounded-10 py-2 px-2 flex-y-center gap-1 transition-300 border border-transparent focus-within:border-[#FBC76C] focus-within:bg-transparent ${className} ${
        disabled && "pointer-events-none"
      }`}
    >
      {prefix}
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type="text"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        className={`bg-transparent outline-none text-sm text-white placeholder:text-gray-1 leading-130 font-medium w-full ${inputClassName}`}
      />
      {suffix}
    </div>
  );
};

export default FormInput;
